import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import FacebookIcon from 'mdi-react/FacebookIcon';
import GooglePlusIcon from 'mdi-react/GooglePlusIcon';
import LogInForm from './components/LogInForm';
import { login } from '../../../redux/actions/index';
import appConfig from "../../../config/constants";

var styles = {
  backgroundImage: 'url(' + require('../../../assets/rmc_background.jpg') + ')'
};

class LogIn extends Component {
     constructor(props) {
        super(props);
        this.handleLogin = this.handleLogin.bind(this);
     }

     handleLogin(data){
            const { login, history} = this.props;
            login(data);
            history.push("/dashboard_assets");
     }

     render() {
        return (
          <div className="account" style={styles}>
            <div className="account__wrapper">
              <div className="account__card">
                <div className="account__head">
                  <h3 className="account__title">Welcome to
                    <span className="account__logo"> RMC
                      <span className="account__logo-accent"> AI4AI </span>
                      Center
                    </span>
                  </h3>
                  {appConfig.APP == "ANOMALY"?
                  <h4 className="account__subhead subhead">Accelerator for Sophisticated AI Driven Anomaly Detection Solutions</h4>
                  :
                  <h4 className="account__subhead subhead">Accelerator for AI Driven Smart Industry & IOT Applications</h4>
                  }
                </div>
                <LogInForm onSubmit={this.handleLogin} />
              </div>
            </div>
          </div>
        );
     }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    login
  }, dispatch);
}


export default (connect(null, mapDispatchToProps)(LogIn));